export const formatDate = (dateString) => {
    if (dateString) {
        const date = new Date(dateString);
        const moscowDate = new Date(date.getTime() + 3 * 60 * 60 * 1000);

        const day = String(moscowDate.getUTCDate()).padStart(2, '0');
        const month = String(moscowDate.getUTCMonth() + 1).padStart(2, '0');
        const year = moscowDate.getUTCFullYear();
        return `${day}.${month}.${year}`;
    } else {
        return "—";
    }
};
export const formatDateTime = (isoDate) => {
    if (!isoDate) return 'Некорректная дата';

    const date = new Date(isoDate);
    if (isNaN(date.getTime())) return 'Некорректная дата';

    const moscowDate = new Date(date.getTime() + 3 * 60 * 60 * 1000);

    const day = String(moscowDate.getUTCDate()).padStart(2, '0');
    const month = String(moscowDate.getUTCMonth() + 1).padStart(2, '0');
    const year = moscowDate.getUTCFullYear();

    const hours = String(moscowDate.getUTCHours()).padStart(2, '0');
    const minutes = String(moscowDate.getUTCMinutes()).padStart(2, '0');
    const seconds = String(moscowDate.getUTCSeconds()).padStart(2, '0');

    return `${day}.${month}.${year} ${hours}:${minutes}:${seconds}`;
};
export const formatComment = (comment) => {
    if (!comment) {
        return <span className='description'>Сообщение отсутствует</span>
    } else {
        return <span>{comment}</span>;
    }
};
export const formatOverflow = (data, characterCount=50) => {
    if (data.length > characterCount) {
        return data.slice(0, characterCount) + '...';
    }
    return data;
};
export const formatNull = (data) => {
    if (data === '' || data === undefined || data === null) {
        return <span className='description'>—</span>
    }else {
        return data;
    }
};

// Функция покраски строки дела в красный, если оно просрочено
export const getCaseStyle = (dateEnd, dateCourt, dateAMAppointment, status) => {
    const todayMSC = new Date();
    todayMSC.setHours(todayMSC.getHours() + 3); // Перевод времени в МСК

    const isPastCourtDate = dateCourt && new Date(dateCourt) < todayMSC && !dateAMAppointment && status !== 'Завершено';

    if (isPastCourtDate) {
        return { border: '1px solid rgb(56, 0, 0)', backgroundColor: 'rgb(255, 240, 240)' }; // Бордовый стиль
    }

    if (!dateEnd) {
        return { border: '1px solid blue', backgroundColor: 'rgb(235, 245, 255)' }; // Синий стиль
    }

    const isPastEndDate =
        new Date(dateEnd) < todayMSC && status !== 'Завершено';

    if (isPastEndDate) {
        return { border: '1px solid rgb(255, 14, 14)', backgroundColor: 'rgb(255, 247, 247)' }; // Красный стиль
    }

    return {}; // Если нет условий, оставить стиль по умолчанию
};

export const isWithinLastHalfHour = (creationTime) => {
    const now = new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Moscow' }));
    const creationDate = new Date(creationTime); // creationTime в UTC

    const diffInMinutes = (now - creationDate) / (1000 * 60);
    return diffInMinutes <= 30;
};

export const pluralizeMonth = (n) => {
    const lastDigit = n % 10;
    const lastTwoDigits = n % 100;

    if (lastTwoDigits >= 11 && lastTwoDigits <= 14) {
        return 'месяцев';
    }

    if (lastDigit === 1) {
        return 'месяц';
    } else if (lastDigit >= 2 && lastDigit <= 4) {
        return 'месяца';
    } else {
        return 'месяцев';
    }
}
export const pluralizeAppointments = (n) => {
    const lastDigit = n % 10;
    const lastTwoDigits = n % 100;

    if (lastTwoDigits >= 11 && lastTwoDigits <= 14) {
        return 'утверждений';
    }

    if (lastDigit === 1) {
        return 'утверждение';
    } else if (lastDigit >= 2 && lastDigit <= 4) {
        return 'утверждения';
    } else {
        return 'утверждений';
    }
}



export const normalizeDate = (dateInput) => {
  const date = new Date(dateInput);
  return !isNaN(date.getTime()) ? date.toISOString().split('T')[0] : null;
}

export const isDatePastInMoscow = (dateStr, addYears = 0) => {
    if (!dateStr) return false;

    const date = new Date(dateStr);
    // Прибавляется нужное количество лет
    date.setFullYear(date.getFullYear() + addYears);

    const now = new Date();
    now.setHours(now.getHours() + 3); // перевод в МСК (UTC+3)

    return date < now;
};

// Проверка, что дата не позднее последних 15 минут по МСК
export function isWithinLast15MinutesMoscow(dateString) {
  const createdAt = new Date(dateString);
  const now = new Date();
  
  // Текущее время по МСК
  const nowMoscow = new Date(now.getTime() + 3 * 60 * 60 * 1000);
  
  const diffMs = nowMoscow - createdAt;
  const FIFTEEN_MINUTES = 15 * 60 * 1000;

  return diffMs <= FIFTEEN_MINUTES && diffMs >= 0;
}

export const formatCaseStatus = (status, format='textPill', fontSize='', element) => {
        return element!=='a' ? 
        <p 
            style={{width: 'fit-content', fontSize: fontSize}}
            className={`
                ${format=='textPill' ? 'textPill' : 'colorCell'} 
                ${status === 'Заявка' ? 'yellow' : ''}
                ${status === 'Управляющий не назначен' ? 'orange' : ''}
                ${status === 'Управляющий отстранен' ? 'red' : ''}
                ${status === 'Управляющий освобожден' ? '' : ''}
                ${status === 'Завершено' ? 'green' : ''}
            `}
        >
            {status}
        </p>
        :
        <a
            style={{width: 'fit-content', fontSize: fontSize}}
            className={`
                ${format=='textPill' ? 'textPill' : 'colorCell'} 
                ${status === 'Заявка' ? 'yellow' : ''}
                ${status === 'Управляющий не назначен' ? 'orange' : ''}
                ${status === 'Управляющий отстранен' ? 'red' : ''}
                ${status === 'Управляющий освобожден' ? '' : ''}
                ${status === 'Завершено' ? 'green' : ''}
            `}
        >
            {status}
        </a>
};

export const getNameForImportantEventsType = (type) => {
    switch (type) {
        case 'add_verification_code':
            return 'Добавление кода восстановления доступа';
        case 'file_deleted':
            return 'Удаление файла';
        case 'change_system_settings':
            return 'Изменение системных настроек';
        case 'am_has_been_selected':
            return 'Назначение управляющего';
        case 'user_role_changed':
            return 'Изменение роли пользователя';
        case 'add_appointment_agreement':
            return 'Добавление соглашения о назначении';
        default:
            return `— (${type})`;
    }
};

export const formatBalance = (value) => {
  return new Intl.NumberFormat('ru-RU').format(value);
}